import React, { useState } from "react";
import Table from "react-bootstrap/Table";
import moment from "moment";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import {
  useUpdateReviewMutation,
  useGetReviewsQuery, useRemoveReviewMutation,
} from "../../../store/reducers/adminApi";
import {Link} from "react-router-dom";

const REVIEWS_PER_PAGE = 50;

export function Reviews() {
  // Phase 5: Add pagination state
  const [page, setPage] = useState(1);
  const { isSuccess, isError, error, data, refetch } = useGetReviewsQuery({ page, limit: REVIEWS_PER_PAGE });
  const reviews = data?.reviews || [];
  const pagination = data?.pagination;
  const [updateReview, updateReviewResult] = useUpdateReviewMutation();
  const [removeReview, removeReviewResult] = useRemoveReviewMutation();
  const [loading, setLoading] = useState(false);

  const setApproved = (reviewID, approved) => {
    setLoading(true);
    updateReview({ approved, reviewID })
      .unwrap()
      .then(() => {
        refetch();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onRemoveReview = (reviewID) => {
    const yes = window.confirm("Are you sure you want to delete this review?");
    if (!yes) return;
    setLoading(true);
    removeReview({ reviewID })
        .unwrap()
        .then(() => {
            refetch();
        })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <div>
      {/* Phase 5: Pagination controls */}
      {pagination && (
        <div className="d-flex justify-content-between align-items-center mb-3">
          <span className="text-muted">
            Showing {reviews.length} of {pagination.total || 0} reviews
          </span>
          <div className="d-flex gap-2 align-items-center">
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => setPage(p => Math.max(1, p - 1))}
              disabled={page === 1}
            >
              Previous
            </Button>
            <span className="px-2">Page {page} of {pagination.totalPages || 1}</span>
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => setPage(p => p + 1)}
              disabled={!pagination.hasMore}
            >
              Next
            </Button>
          </div>
        </div>
      )}
      <Table striped bordered>
        <thead>
          <tr>
            <th>Reviewer</th>
            <th>Psychic</th>
            <th>Rating</th>
            <th>Text</th>
            <th>Written On</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {reviews &&
            reviews.map((review) => {
              return (
                <tr key={review.reviewID}>
                  <td>{review.reviewer.username}</td>
                  <td>{review.reviewee.username}</td>
                  <td>{review.rating} / 5</td>
                  <td>{review.text}</td>
                  <td>{moment(review.created_at).format("MM-DD-YYYY HH:mm:ss")}</td>
                  <td>
                    <div className="flex-row" style={{textAlign: 'center'}}>
                      {review.approved ? (
                        <Button
                          disabled={loading}
                          variant="danger"
                          onClick={() => {
                            setApproved(review.reviewID, false);
                          }}
                        >
                          Hide
                        </Button>
                      ) : (
                        <Button
                          disabled={loading}
                          variant="success"
                          onClick={() => {
                            setApproved(review.reviewID, true);
                          }}
                        >
                          Approve
                        </Button>
                      )}

                      <div style={{textAlign: 'center'}}>
                        <a
                            style={{fontSize: 10, textAlign: 'center'}}
                            href={"#"}
                            onClick={() => {
                              onRemoveReview(review.reviewID);
                            }}
                          >
                            Remove
                          </a>
                      </div>
                    </div>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </Table>
    </div>
  );
}
